<template>
    <div>
        <div class="sub_tit">Modify Approver</div>
        <table class="create_table">
            <colgroup>
                <col width="15%" />
                <col width="*" />
                <col width="15%" />
                <col width="*" />
            </colgroup>
            <tbody>
                <tr>
                    <th>Country</th>
                    <td>
                        <span>{{updateParam.countryName}}</span>
                    </td>
                    <th></th>
                    <td>
                        <span></span>
                    </td>
                </tr>
                <tr>
                    <th>First Approver</th>
                    <td>
                        <label class="serach-wrap">
                            <input
                                type="text"
                                class="text_input"
                                placeholder="First Approver"
                                readonly
                                v-model="updateParam.firstApproverId"
                            />
                            <a
                                href="javascript:"
                                class="in_btn_search"
                                @click="openSearchIdPopup('FIRST')"
                            >
                                <i class="ico_input_serach"></i>
                                <span class="sr_only">검색 열기</span>
                            </a>
                        </label>
                    </td>
                    <th>Second Approver</th>
                    <td>
                        <label class="serach-wrap">
                            <input
                                type="text"
                                class="text_input"
                                placeholder="Second Approver"
                                readonly
                                v-model="updateParam.secondApproverId"
                            />
                            <a
                                href="javascript:"
                                class="in_btn_search"
                                @click="openSearchIdPopup('SECOND')"
                            >
                                <i class="ico_input_serach"></i>
                                <span class="sr_only">검색 열기</span>
                            </a>
                        </label>
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- page btn -->
        <div class="btn_wrap_full topLine">
            <a href="javascript:" class="btn_white" @click="onBackToList()">List</a>
            <div class="btn_right">
                <a href="javascript:" class="btn_blue" @click="onUpdateButtonClick">Save</a>
            </div>
        </div>
        <!-- //page btn -->
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import { SDLUtil, StringUtil } from '@/utils';

import SearchIdPopup from './SearchIdPopup';

export default {
    name: '',

    components: {},

    props: {
        countryCode: {
            type: String,
            required: true,
        },
        countryName: {
            type: String,
            required: true,
        },
        firstApproverId: {
            type: String,
            required: true,
        },
        secondApproverId: {
            type: String,
            required: true,
        },
        onBackToList: {
            type: Function,
            required: true,
        },
    },

    computed: {},

    data() {
        return {
            updateParam: {
                countryCode: this.countryCode,
                countryName: this.countryName,
                firstApproverId: this.firstApproverId,
                secondApproverId: this.secondApproverId,
            },
        };
    },

    created() {},

    methods: {
        // init() {},
        openSearchIdPopup(target) {
            let onUserSelect = null;

            if (target === 'FIRST') {
                onUserSelect = userId => (this.updateParam.firstApproverId = userId);
            } else {
                onUserSelect = userId => (this.updateParam.secondApproverId = userId);
            }

            SDLUtil.show(
                SearchIdPopup,
                {
                    title: 'Search ID',
                    onUserSelect,
                },
                {
                    height: 'auto',
                },
            );
        },

        onUpdateButtonClick() {
            const data = this.updateApprovers();

            if (data.result === 0) {
                const title = 'Update Failed!';
                const msg = 'Failed to update approvers!';
                SDLUtil.alert({
                    title,
                    msg,
                });
                return;
            }

            const title = 'Update Succeeded!';
            const msg = 'Approvers have been updated!';
            SDLUtil.alert({
                title,
                msg,
                onOkEvt: () => {
                    const update = true;
                    this.onBackToList(update);
                },
            });
            return;
        },

        async updateApprovers() {
            const params = {
                old_country_cd: this.updateParam.countryCode,
                country_cd: this.updateParam.countryCode,
                f_approver_id: this.updateParam.firstApproverId,
                s_approver_id: this.updateParam.secondApproverId,
            };

            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/anysvcmobile/approvalManagement/approvalMgmt/ApprovalModifyUpdate.skp`,
                    qs.stringify(params),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                    },
                )
                .then(res => {
                    console.log('Update Response', res);
                    return res.data;
                })
                .catch(err => {
                    console.log('Error', err);
                    return err;
                });
        },
    },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/approvalManagement/ApprovalManagementModify.vue